import { computed } from 'vue';

/**
 * Composable to extract translation state/content from contentAttributes.
 * @param {Ref|Reactive} contentAttributes - Ref or reactive object containing `translations` property
 * @returns {Object} { hasTranslations, translationContent, originalLanguage, translatedLanguage }
 */
export function useTranslations(contentAttributes) {
  const hasTranslations = computed(() => {
    if (!contentAttributes.value) return false;
    const { translations = {} } = contentAttributes.value;
    return Object.keys(translations || {}).length > 0;
  });

  const translationContent = computed(() => {
    if (!hasTranslations.value) return null;
    const translations = contentAttributes.value.translations;
    return translations[Object.keys(translations)[0]];
  });

  const translatedLanguage = computed(() => {
    if (!hasTranslations.value) return null;
    const translations = contentAttributes.value.translations;
    return Object.keys(translations)[0];
  });

  const originalLanguage = computed(() => {
    if (!contentAttributes.value) return null;
    // Get from conversation_language stored in content_attributes
    return contentAttributes.value.conversation_language || contentAttributes.value.original_language || null;
  });

  return { 
    hasTranslations, 
    translationContent, 
    originalLanguage, 
    translatedLanguage 
  };
}
